<template>
  <b-dropdown
    :id="dropDownId"
    toggle-class="btn-default"
    class="dropdown visitor-button"
    menu-class="width-max-content"
    @show="setZIndex"
    @hide="unsetZIndex"
    @dblclick.native.stop
    right
    ref="dropdown"
  >
    <template #button-content>
      <i class="fa fa-bars"/>
    </template>
    <slot name="prevItems"></slot>
    <template v-for="(item, key) in items">
      <b-dropdown-item v-if="showMenuItem(item)" :key="key" @click="actionItem(item)">
        <dropdown-image :other-icon-path="iconsPath" :icon-name="item.icon" />
        {{ item.command_name }}
      </b-dropdown-item>
    </template>

    <b-dropdown-item v-if="visibleCloseButton" @click="closeVisitor">
      <dropdown-image :icon-name="closeButtonIcon" :alt="closeButtonText" />
      {{ closeButtonText }}
    </b-dropdown-item>

    <b-dropdown-item v-if="visibleIssuePassButtons" @click="issuePass">
      <dropdown-image icon-name="v_pass.svg" />
      {{ issuePassText }}
    </b-dropdown-item>

    <b-dropdown-item v-if="visiblePrintPassButtons" :href="passUrl" target="_blank">
      <dropdown-image icon-name="v_print.svg" />
      {{ printPassText }}
    </b-dropdown-item>

    <b-dropdown-item v-if="visibleVisitorSendToSolvoButton" @click="sendSolvoXml">
      <dropdown-image icon-name="v_solvo.svg" />
      Передать в Solvo.TOS
    </b-dropdown-item>

    <b-dropdown-item v-if="visibleVisitorSendToSkudButton" @click="sendScudXml">
      <dropdown-image icon-name="v_skud.svg" />
      Передать в СКУД
    </b-dropdown-item>

    <slot name="lastItems"></slot>
  </b-dropdown>
</template>

<script>
import applicationFormMixin from '../../mixins/applicationFormMixin'
import mainMixin from '../../mixins/mainMixin'
import { ApiClient } from '../../helpers/api-client/ApiClient'
import visitorBlockMixin from '../../mixins/application-form/visitorBlockMixin'
import '@/common/assets/styles/visitor-menu-style.scss'
import actionListMenuMixin from '../../mixins/actionListMenuMixin'
import DropdownImage from './menu-components/DropdownImage.vue'

export default {
  name: 'VisitorActionListMenu',

  components: {
    DropdownImage
  },

  mixins: [
    actionListMenuMixin,
    applicationFormMixin,
    mainMixin,
    visitorBlockMixin
  ],

  props: {
    application: {
      type: Object,
      required: true
    },
    applicationKey: {
      type: Number,
      required: true
    },
    approvalCommand: {
      type: Function,
      required: true
    },
    baseUrl: String,
    getSigner: {
      type: Function,
      required: true
    },
    transports: {
      type: [Object, Array],
      default: () => ({ id: 0 })
    },
    visitor: {
      type: Object,
      default: () => {}
    },
    visitorKey: {
      type: Number,
      required: true
    }
  },

  data: () => {
    return {
      status: null,
      cfgMenuVisitor: []
    }
  },

  computed: {
    applicationId() {
      return Number(this.application.id)
    },

    closeButtonIcon() {
      return this.visitor.access ? 'v_accept.svg' : 'v_denied.svg'
    },

    closeButtonText() {
      return (this.visitor.access ? 'Разрешить' : 'Запретить') + ' доступ'
    },

    dropDownId() {
      return `visitor-dropdown-${this.visitorKey}-${this.applicationKey}`
    },

    iconsPath() {
      return this.baseUrl + '/img/icons/statuses/'
    },

    inScud() {
      return this.application.inScud
    },

    isGivePassPeriod() {
      return !!this.cfgMenuVisitor.give_pass_period
    },

    isIssued() {
      return Boolean(
        this.visitor &&
        this.visitor.personal &&
        this.visitor.personal.isIssued
          ? this.visitor.personal.isIssued : false
      )
    },

    issuePassText() {
      return this.visibleVisitorIssuePassPeriodButton ? 'Выдать пропуска' : 'Выдать пропуск'
    },

    items() {
      return this.application.statusActions
    },

    passUrl() {
      return this.getGivePassUrl(this.isGivePassPeriod)
    },

    personalId() {
      return Number(this.visitor.personal.id)
    },

    printPassText() {
      return this.visibleVisitorPrintPassPeriodButton ? 'Распечатать пропуска' : 'Распечатать пропуск'
    },

    transportId() {
      return this.transports.length > 0 ? this.transports[0].id : null
    },

    visibleIssuePassButtons() {
      return (this.visibleVisitorIssuePassButton || this.visibleVisitorIssuePassPeriodButton) && !this.isIssued
    },

    visiblePrintPassButtons() {
      return this.visibleVisitorPrintPassButton || this.visibleVisitorPrintPassPeriodButton
    }
  },

  methods: {
    actionItem(item) {
      return item.esignature === '1'
        ? this.getSigner(this.application, item)
        : this.approvalCommand(this.application, item, this.applicationKey)
    },

    closeVisitor() {
      ApiClient.changeVisitorAccess({
        visitor_id: this.personalId,
        appId: this.applicationId
      }).then((response) => {
        if (response?.data?.status === 'success') {
          this.$set(this.visitor, 'access', this.visitor.access ? 0 : 1)
          this.visitor.access
            ? Number(++this.application.visitorsCloseCount)
            : Number(--this.application.visitorsCloseCount)
        }
      })
    },

    fetchCfgMenuVisitor() {
      ApiClient.cfgMenuData({
        id: this.applicationId,
        type: 'visitor'
      }).then((response) => {
        this.cfgMenuVisitor = response.data.data
      })
    },

    getGivePassUrl(isGivePassPeriod) {
      return String(
        this.baseUrl + '/pdf/pass?' +
        'applicationId=' + this.applicationId +
        '&visitorId=' + this.visitor.personal.id +
        '&isGivePassPeriod=' + isGivePassPeriod ?? false
      )
    },

    issuePass() {
      ApiClient.issuePass({
        visitor_id: this.visitor.personal.id,
        appId: this.applicationId
      }).then((result) => {
        if (result && result.data.status === 'success') {
          this.visitor.personal.isIssued = true
          const isGivePassPeriod = !!this.cfgMenuVisitor.give_pass_period
          window.open(this.getGivePassUrl(isGivePassPeriod), '_blank')
        }
      }).catch(function () {
        alert('Не удалость выдать пропуск.')
      })
    },

    setZIndex(bvEvent) {
      const dropDown = document.getElementById(bvEvent.componentId)
      dropDown.style.zIndex = '2'
      if (this.cfgMenuVisitor.length === 0) {
        this.fetchCfgMenuVisitor()
      }
    }
  }
}
</script>
